import axiosInstance from 'services/axiosInstance';

export async function apiExport(url: string): Promise<void> {
  try {
    const response = await axiosInstance.get(url, {
      responseType: 'blob', // Importante para lidar com PDFs
    });

    console.log('Export: ', response);

    // Criar um Blob a partir da resposta
    const file = new Blob([response.data], { type: 'application/pdf' });

    // Criar uma URL para o Blob
    const fileURL = URL.createObjectURL(file);

    // Abrir o PDF em uma nova aba
    window.open(fileURL, '_blank');
  } catch (error) {
    console.error('Error exporting data:', error);
    throw error; // Propague o erro para ser tratado na chamada
  }
}
